import { render } from "./device-type-form.vue?vue&type=template&id=3f2478da"
import script from "./device-type-form.vue?vue&type=script&lang=js"
export * from "./device-type-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__